<template>
  <v-card class="lighten-12 card-content pa-4">
    <v-row>
      <v-col lg="8" sm="12" md="8" class="d-flex">
        <span>
          <h2>{{ selectedPeriodRange }}</h2>
        </span>

        <span class="headerstyle">
          <b>
            <span>
              {{ Title }}
            </span>
          </b>
        </span>
      </v-col>
      <v-col sm="4" md="4" lg="4">
        <v-select
          style="z-index: 15"
          :items="itemsData"
          item-text="title"
          v-model="selectedPeriodRange"
          label="Date Range"
          dense
          @input="ClickToRange"
          solo
        ></v-select>
      </v-col>
    </v-row>
    <apexchart
      width="100%"
      :type="ChartType"
      :options="options"
      :series="series"
    ></apexchart>
  </v-card>
</template>

<script>
export default {
  data: () => ({}),
  props: {
    ChartType: {
      type: String,
      default: 'area',
    },
    Title: {
      type: String,
      default: '',
    },
    selectedPeriodRange: {
      type: String,
      default: '',
    },
    itemsData: {
      type: Array,
      default: [],
    },
    options: {
      // type: Array,
      // default: [],
      type: Object,
      default: {},
    },
    series: {
      type: Array,
      default: [],
    },
  },

  methods: {
    ClickToRange(item) {
      this.$emit('LoadData', item);
    },
  },
};
</script>
<style>
.headerstyle {
  margin-top: 7px;
  margin-left: 2%; /* space between days and warehouse */
}

.chartAlignment {
  width: 90% !important;
}

.textSize {
  font-weight: 900;
}
</style>
